module.exports = flarum.core.compat['forum/tags/components/TagsPage'];